




























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import PageNation from '../../components/organisms/PageNation.vue';
import SortTh from '../../components/atoms/SortTh.vue';
import { Sorter } from '../../utils/Sorter';
import TeachersRow from './TeachersRow.vue';
import TeacherInfoMaintenance from './TeacherInfoMaintenance.vue';
import NoData from './NoData.vue';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';
import { buildingData } from '../../../src_server/entity/master/buildingData';
import { Session } from '../../utils/Session';

@Component({
  components: { CommonDialog, PageNation, SortTh, TeachersRow, TeacherInfoMaintenance, NoData },
})
export default class DaTeacherPage extends Vue {
  private selectedRow: TeacherInfoInputDTO = new TeacherInfoInputDTO();
  private teacherRows: TeacherInfoInputDTO[] = []; // フィルタリング後の全行
  private dispRows: TeacherInfoInputDTO[] = []; // ページで表示中の行
  private selectedTeacher = {};
  private loading = false;

  get showHiddenOptions() {
    return [
      { value: true, title: '' },
      { value: false, title: '非表示も表示' },
    ];
  }
  private _isHidden = true;
  get isHidden() {
    return this._isHidden;
  }
  set isHidden(value: boolean) {
    this._isHidden = value;
    this.loadData(Session.getSessionBuildingId()).then();
  }

  // デフアカオンラインとテスト校舎以外（デフアカデミー）の校舎データを返す
  get buildings() {
    return buildingData.filter((d) => d.building_id !== 'co01' && d.building_id !== 'test');
  }

  async addTeacher() {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.show(new TeacherInfoInputDTO(), 'add');
    console.log('add');
  }

  async loadData(building_id: string) {
    this.loading = true;
    const biz = new DaTeacherService();
    const response = await biz.getTeachers(building_id);
    this.teacherRows = response.data;

    // 管理ページ内で表示するクラスのみ表示
    this.teacherRows = this.teacherRows.filter((i) => {
      if (this._isHidden) {
        return i.da_teacher.is_shown_admin_page;
      } else {
        return true;
      }
    });

    this.loading = false;
  }

  detail(row: any) {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.show(row, 'detail');
  }

  cancel() {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.hide();
  }

  mounted() {
    this.loadData(Session.getSessionBuildingId()).then();
  }

  @Watch('teacherRows')
  pageChanged(rows: any[]) {
    // console.log(rows);
    this.dispRows = rows;
  }

  added(info: TeacherInfoInputDTO) {
    this.teacherRows.splice(0, 0, info);
  }

  updatedInfo(info: TeacherInfoInputDTO) {
    const index = this.teacherRows.findIndex((i) => i.userAuth.user_id === info.userAuth.user_id);
    this.teacherRows.splice(index, 1, info);

    // 非表示に設定したら消す
    this.teacherRows = this.teacherRows.filter((r) => r.da_teacher.is_shown_admin_page);
  }

  sortBy(up: boolean, target: string) {
    console.log(target, up);
    this.teacherRows = this.teacherRows.sort(Sorter.compareByPath(target, up));
  }

  deleted(user_id: string) {
    console.log('user_id', user_id);
    const index = this.dispRows.findIndex((t) => {
      return t.userAuth.user_id === user_id;
    });
    this.dispRows.splice(index, 1);
  }

  copyed(info: TeacherInfoInputDTO) {
    this.dispRows.unshift(info);
    console.log(info);
  }
}
